import React from 'react';
import PropTypes from 'prop-types';
import {Col, Collapse} from "reactstrap";
import Chips from "../index";
import * as _ from 'lodash';

ChipsContainer.propTypes = {
    isContentList: PropTypes.bool.isRequired,
    isFilterApplied: PropTypes.bool.isRequired,
    pricingType: PropTypes.string.isRequired,
    setPricingType: PropTypes.func.isRequired,
    contentType: PropTypes.string.isRequired,
    setContentType: PropTypes.func.isRequired,
    sortBy: PropTypes.string.isRequired,
    setSortBy: PropTypes.func.isRequired,
    resetFilters: PropTypes.func.isRequired,
};

function ChipsContainer(props) {
    const pricingType = props.pricingType;
    const pricingTypeArray = props.pricingType.split(",");
    const contentType = props.contentType;
    const contentTypeArray = props.contentType.split(",");
    const sortBy = props.sortBy;

    return (
        <Collapse isOpen={props.isContentList && props.isFilterApplied}>
            <Col sm="12" className="p-3 mb-3">
                {
                    pricingType.toLowerCase() !== "all" && _.map(pricingTypeArray, (price) => {
                        return (
                            <Chips
                                text={_.capitalize(price)}
                                action={() => {
                                    props.setPricingType(price)
                                }}
                            />
                        )
                    })
                }

                {
                    contentType.toLowerCase() !== "all" && _.map(contentTypeArray, (content) => {
                        return (
                            <Chips
                                text={_.capitalize(content)}
                                action={() => {
                                    props.setContentType(content)
                                }}
                            />
                        )
                    })
                }

                {
                    sortBy !== "new" &&
                    <Chips
                        text={sortBy}
                        action={() => {
                            props.setSortBy("new")
                        }}
                    />
                }
                {
                    props.isFilterApplied &&
                    <Chips
                        hideCross
                        text={"Remove All Filters"}
                        action={() => {
                            props.resetFilters();
                        }}
                    />
                }
            </Col>
        </Collapse>
    );
}

export default ChipsContainer;